import { render, staticRenderFns } from "./Movimiento.vue?vue&type=template&id=4925a0c2&"
import script from "./Movimiento.vue?vue&type=script&lang=js&"
export * from "./Movimiento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports